import { enumItems } from './enumItems';
import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SelectField } from '../components/Table/fields/SelectField';
import { DateField } from '../components/Table/fields/DateField';
import { SetField } from '../components/Table/fields/SetField';
import { CustomFieldForPromotionActivities } from '../components/Table/fields/CustomFieldForPromotionActivities';

export const promotions: SchemaWithClient<any> = {
  name: 'Promotions',
  pluralName: 'Promotions',
  columns: {
    name: {
      name: 'Name',
      required: true,
      fieldRenderer: TextField,
      fieldType: 'text',
    },
    activities_with_prices: {
      name: 'Activities',
      required: false,
      fieldRenderer: SetField.tableAdapter(enumItems.activity),
      slidePaneFieldRenderer: CustomFieldForPromotionActivities,
      fieldType: 'custom',
      hideInTableView: true,
    },
    booking_interval_from: {
      name: 'Booking Interval Start',
      fieldRenderer: DateField,
      fieldType: 'date',
      width: 'medium',
    },
    booking_interval_to: {
      name: 'Booking Interval To',
      fieldRenderer: DateField,
      fieldType: 'date',
      width: 'medium',
    },
    stay_interval_from: {
      name: 'Stay Interval Start',
      fieldRenderer: DateField,
      fieldType: 'date',
      width: 'medium',
    },
    stay_interval_to: {
      name: 'Stay Interval To',
      fieldRenderer: DateField,
      fieldType: 'date',
      width: 'medium',
    },
    sales_partners: {
      name: 'Sales Partners',
      fieldRenderer: SetField.tableAdapter(enumItems.salesPartner),
      multiSwitchboard: true,
      url: enumItems.salesPartner.client.getAllPath,
      tempSchema: enumItems.salesPartner,
    },
    currency: {
      name: 'Currency',
      fieldRenderer: SelectField.tableAdapter(enumItems.currency),
      switchboard: true,
      url: enumItems.currency.client.getAllPath,
      tempSchema: enumItems.currency,
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/promotions'),
};
